<div class="header">
  <div *ngIf="showBackButton" (click)="navigateBack()" class="header-back clickable">
    <mat-icon>chevron_left</mat-icon>
  </div>
  <div class="header-title-wrapper vcenter">
    <div class="header-title vcenter">{{ title }}</div>
    <ng-container *ngIf="subtitle">
      <div class="text-small">{{ subtitle }}</div>
    </ng-container>
    <div class="header-button">
      <ng-template headerButton></ng-template>
    </div>
  </div>
</div>
